/* eslint-disable import/prefer-default-export */
import React from 'react';
import { oneOfType, PropTypes } from 'prop-types';
import get from 'lodash/get';
import Skeleton from 'Common/Components/Skeleton';
import { Wrapper, Link } from './styled';

export const CWE = ({ vuln, showSkeleton }) => {
  const cwes = get(vuln, 'cwe', []).filter(Boolean);

  if (showSkeleton) return <Skeleton />;
  return (
    <Wrapper>
      {cwes.map((cwe) => (
        <Link
          target="_blank"
          rel="noopener noreferrer"
          href={ `https://cwe.mitre.org/data/definitions/${cwe.replace('CWE-', '').replace('cwe-', '')}.html` }
          children={ cwe }
          key={ cwe }
        />
      ))}
    </Wrapper>
  );
};

CWE.propTypes = {
  vuln: oneOfType([PropTypes.object, PropTypes.number]).isRequired,
  showSkeleton: PropTypes.bool.isRequired
};
